import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import Tabs from "../tabs.component";

class OrdersTabs extends Component {

    constructor(props, context) {
        super(props, context)
    }

    render() {
        return (
            <Tabs value={[
                {
                    name: <FormattedMessage
                        id="menu.tabs.orders.orders"
                        defaultMessage="Orders"
                    />,
                    link: '/orders/listing',
                },
                {
                    name: <FormattedMessage
                        id="menu.tabs.orders.item_report"
                        defaultMessage="Item Report"
                    />,
                    link: '/orders/item-report',
                },
            ]} />
        );
    }
}

export default OrdersTabs


// WEBPACK FOOTER //
// ./src/common/layout/tabs/orders.component.jsx